<template>
  <div>
    <div class="status">
      <span class="status-txt"
        >当前订单状态：{{ orderStatusObj[orderInfo.integralOrderState] }}</span
      >
      <el-button
        type="primary"
        plain
        v-if="orderInfo.integralOrderState == 4"
        @click="onExpress"
        >发货</el-button
      >
      <el-button
        type="primary"
        plain
        v-if="
          orderInfo.integralOrderState == 4 || orderInfo.integralOrderState == 2
        "
        @click="onReplace"
        >订单转换</el-button
      >
    </div>
    <div class="base-info">
      <div class="title">基本信息</div>
      <div class="content-box">
        <el-row type="flex" align="middle" justify="center" class="row">
          <p class="txt">订单编号：{{ orderInfo.id }}</p>
          <p class="txt">
            拥有账号：<span class="theme" @click="onJumpRember">{{
              orderInfo.userName
            }}</span>
          </p>
          <p class="txt">抵扣积分：{{ orderInfo.totalIntegralNum }}</p>
        </el-row>
        <el-row type="flex" align="middle" justify="center" class="row">
          <p class="txt">兑换时间：{{ orderInfo.createTime }}</p>
          <p class="txt">
            配送方式：{{
              orderInfo.integralOrderType === 1 ? '快递配送' : '门店自提'
            }}
          </p>
          <p class="txt">物流单号：{{ orderInfo.expressNum || '--' }}</p>
        </el-row>
      </div>
    </div>
    <div class="base-info" v-if="orderInfo.integralOrderType == 1">
      <div class="title">收货人信息</div>
      <div class="mt">
        <el-table :data="addressList" border style="width: 100%">
          <el-table-column prop="receiveUserName" label="收货人" align="center">
          </el-table-column>
          <el-table-column prop="receivePhone" label="手机号码" align="center">
          </el-table-column>
          <el-table-column
            prop="receiveAddress"
            label="收货地址"
            align="center"
          >
          </el-table-column>
        </el-table>
      </div>
    </div>
    <div class="base-info" v-if="orderInfo.integralOrderType == 2">
      <div class="title">自提门店信息</div>
      <div class="mt">
        <el-table :data="shopData" border style="width: 100%">
          <el-table-column prop="shopName" label="门店名称" align="center">
          </el-table-column>
          <el-table-column prop="shopAddress" label="门店地址" align="center">
          </el-table-column>
          <el-table-column prop="shopPhone" label="门店电话" align="center">
          </el-table-column>
        </el-table>
      </div>
    </div>
    <div class="base-info">
      <div class="title">商品信息</div>
      <div class="mt">
        <el-table
          :data="orderInfo.integralOrderDetails"
          border
          style="width: 100%"
        >
          <el-table-column label="商品图片" align="center">
            <template slot-scope="scope">
              <img :src="scope.row.productUrl" class="pic" />
            </template>
          </el-table-column>
          <el-table-column prop="productName" label="商品名称" align="center">
          </el-table-column>
          <el-table-column prop="integralNum" label="所需积分" align="center">
          </el-table-column>
          <el-table-column prop="productNum" label="数量" align="center">
          </el-table-column>
          <el-table-column prop="integralNum" label="小计" align="center">
          </el-table-column>
        </el-table>
        <div class="total">
          合计: <span>{{ total }}积分</span>
        </div>
      </div>
    </div>
    <!-- 发货 -->
    <DeliverDialog
      :visible.sync="showDelivery"
      :loading="loading1"
      @confirm="onConfirmDelivery"
    >
    </DeliverDialog>
    <!-- 转自提 -->
    <SelectShopDialog
      :visible.sync="showSelectShop"
      :options="shopList"
      :loading="loading2"
      @confirm="onReplaceShop"
    >
    </SelectShopDialog>
    <!-- 转快递 -->
    <SelectDeliverDialog
      :visible.sync="showSelectDeliver"
      :loading="loading3"
      @confirm="onReplaceDelivery"
    >
    </SelectDeliverDialog>
  </div>
</template>
<script>
import DeliverDialog from './components/DeliverDialog.vue';
import SelectShopDialog from './components/SelectShopDialog.vue';
import SelectDeliverDialog from './components/SelectDeliverDialog.vue';
import {
  getIntegralOrderById,
  addExpressCompany,
  replaceOrder,
} from '@/api/exchange';
import { getShopList } from '@/api/stores';
import { orderStatusObj } from '@/utils/util';

export default {
  name: 'orderDetail',
  components: {
    DeliverDialog,
    SelectShopDialog,
    SelectDeliverDialog,
  },
  data() {
    return {
      orderStatusObj,
      addressList: [],
      orderId: '',
      orderInfo: {},
      total: 0,
      showDelivery: false,
      showSelectShop: false,
      showSelectDeliver: false,
      loading1: false,
      loading2: false,
      loading3: false,
      shopList: [],
      shopData: [], // 自提门店信息
    };
  },
  mounted() {
    this.orderId = this.$route.query.id;
    this.getDetail();
    this.getShop();
  },
  methods: {
    getShop() {
      getShopList({
        page: 1,
        pageSize: 1000,
      }).then((res) => {
        if (res.success) {
          this.shopList = res.data.list || [];
        } else {
          this.$message.error(res.message);
        }
      });
    },
    getDetail() {
      getIntegralOrderById({ id: this.orderId }).then((res) => {
        if (res.success) {
          this.orderInfo = res.data;
          this.total = this.orderInfo.integralOrderDetails.reduce(
            (total, item) => total + item.integralNum,
            0,
          );
          const {
            receiveAddress,
            receivePhone,
            receiveUserName,
            shop,
          } = res.data;
          const address = {
            receiveAddress,
            receivePhone,
            receiveUserName,
          };
          this.addressList = [address];
          this.shopData = [shop];
        } else {
          this.$message.error(res.message);
        }
      });
    },
    onJumpRember() {
      this.$router.push({
        path: '/prefer/prefervip/detail',
        query: { id: this.orderInfo.userId },
      });
    },
    // 发货
    onExpress() {
      this.showDelivery = true;
    },
    onConfirmDelivery(data) {
      this.loading1 = true;
      addExpressCompany({ id: this.orderInfo.id, ...data }).then((res) => {
        this.loading1 = false;
        if (res.success) {
          this.$message.success('发货成功');
          this.showDelivery = false;
          this.getDetail();
        } else {
          this.$message.error(res.message);
        }
      });
    },
    // 订单转换
    onReplace() {
      const { integralOrderType } = this.orderInfo;
      if (integralOrderType === 1) {
        // 快递转自提
        this.showSelectShop = true;
      } else {
        this.showSelectDeliver = true;
      }
    },
    // 快递转自提
    onReplaceShop(data) {
      this.onReplaceOperate(data, 'loading2', 'showSelectShop');
    },
    // 自提转快递
    onReplaceDelivery(data) {
      this.onReplaceOperate(data, 'loading3', 'showSelectDeliver');
    },
    onReplaceOperate(data, loadingKey, showKey) {
      const { id, integralOrderState, integralOrderType } = this.orderInfo;
      const params = {
        id,
        integralOrderState,
        integralOrderType,
        ...data,
      };
      this[loadingKey] = true;
      replaceOrder(params).then((res) => {
        this[loadingKey] = false;
        if (res.success) {
          this.$message.success('操作成功');
          this[showKey] = false;
          this.getDetail();
        } else {
          this.$message.error(res.message);
        }
      });
    },
  },
};
</script>
<style lang="stylus" scoped>
.status
  padding 20px 24px 24px
  background #f5f5f7
  border 1px solid #ddd
  color #333
  font-size 16px
  margin-bottom 16px
  .status-txt
    padding-right 32px
.base-info
  margin-top 24px
  .title
    color #333
    font-size 16px
    font-weight 700
  .content-box
    padding 24px 24px 0
    background #f5f5f7
    border 1px solid #ddd
    margin-top 16px
    .row
      padding-bottom 24px
    .txt
      width 33.33%
      color #666
  .mt
    margin-top 16px
  .total
    height 64px
    line-height 64px
    background #f5f5f7
    border 1px solid #eee
    border-top: 0;
    text-align right
    span
      color #1890ff
      padding: 0 40px 0 20px
  .theme
    color #1890ff
    cursor pointer
  .pic
    width 72px
    height 72px
</style>
